import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

import { assetImagePath } from 'interfaces/constants'
// } from 'styles/breakpoint'

export const StyledContent = styled.div`
  ${MediaQueries.mbUp} {
    padding-bottom: 176px;
  }
  ${MediaQueries.mbDown} {
    padding-bottom: 44px;
  }
`

export const StyledSubmitButton = styled.div`
  margin: 0 auto;
  margin-bottom: 32px;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }

  ${MediaQueries.mbUp} {
    max-width: 195px;
  }
`

export const StyledRightColumnContainer = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
  .top-ad {
    margin-bottom: 2rem;
  }
`

export const StyledTab = styled.div`
  margin-bottom: 12px;
`

export const StyledTabContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 48px;
  row-gap: 12px;

  & > :first-of-type {
    margin-bottom: 8px;
  }
`

export const StyledInfoCard = styled.div`
  padding-top: 32px;

  & > div {
    margin-bottom: 24px;
  }

  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const StyleContainerHeaderResult = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  margin-bottom: 48px;
  ${MediaQueries.mbDown} {
    padding: 8px 16px;
    gap: 40px;
    margin-bottom: 40px;
  }
`
export const StyleExplainChart = styled.div`
  position: relative;
  width: 343px;
  height: 343px;
  background-image: url('${assetImagePath}/pwg-chart.svg');
  .extra {
    position: absolute;
    top: 32px;
    left: 259px;
  }
  .breast {
    position: absolute;
    top: 286px;
    left: 225px;
  }
  .uterus {
    position: absolute;
    top: 307px;
    left: 134.5px;
  }

  .placenta {
    position: absolute;
    top: 252px;
    left: 2px;
  }
  .baby {
    position: absolute;
    top: 119px;
    left: 2px;
  }
  .amniotic {
    position: absolute;
    top: 34px;
    left: 33px;
  }
`

export const FormControl = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`
